import { labelsEn } from './labels-en';
export const labelsEs = {
  ...labelsEn,
  title: 'Etiquetas y marcado',
  subtitle: 'Etiquetas multilingües versionadas basadas en datos de producto aprobados.',
  active: 'Activo',
  inactive: 'Inactivo',
  autoReleased: 'Última versión aprobada',
  help: { open: 'Abrir ayuda de etiquetas' },
  tabs: {
    templates: 'Plantillas',
    formats: 'Formatos',
    prints: 'Historial de impresión',
    design: 'Diseño',
    previewPrint: 'Vista previa e impresión',
  },
  templates: {
    title: 'Plantillas de etiquetas',
    description:
      'El modo de etiqueta reutiliza el diseñador PDF central y congela cada versión aprobada.',
    create: 'Nueva plantilla',
    createDescription: 'Comience con un formato físico validado y un diseño inicial.',
  },
  formats: {
    title: 'Formatos de etiquetas',
    description: 'Configure hojas, rollos, cuadrículas, márgenes y separaciones en milímetros.',
    create: 'Nuevo formato',
    edit: 'Editar formato',
  },
  prints: {
    title: 'Historial de impresión',
    description: 'Evidencia inmutable de pruebas, producción y reimpresiones en el DMS.',
  },
  designer: {
    subtitle: 'Versión de plantilla {{version}}',
    elements: 'Elementos',
    canvas: 'Área de etiqueta',
    inspector: 'Propiedades',
    selectElement: 'Seleccione un elemento para editarlo.',
  },
  preview: {
    title: 'Instantánea de datos',
    description:
      'Seleccione datos reales del ERP. El servidor valida y genera la misma instantánea utilizada para imprimir.',
    legalTitle: 'Revisión obligatoria',
    legalWarning:
      'Las declaraciones y el contenido legal de la etiqueta deben ser revisados y aprobados expresamente por personal cualificado antes de un uso vinculante.',
    pdf: 'Vista previa PDF del servidor',
    empty: 'Seleccione los datos y genere una vista previa.',
  },
  fields: {
    ...labelsEn.fields,
    name: 'Nombre',
    description: 'Descripción',
    mediaType: 'Tipo de soporte',
    active: 'Activo',
    pageWidthMm: 'Ancho de página (mm)',
    pageHeightMm: 'Alto de página (mm)',
    labelWidthMm: 'Ancho de etiqueta (mm)',
    labelHeightMm: 'Alto de etiqueta (mm)',
    columns: 'Columnas',
    rows: 'Filas',
    marginLeftMm: 'Margen izquierdo (mm)',
    marginTopMm: 'Margen superior (mm)',
    horizontalGapMm: 'Separación horizontal (mm)',
    verticalGapMm: 'Separación vertical (mm)',
    format: 'Formato',
    text: 'Texto',
    dynamicField: 'Campo de datos dinámico',
    analysisParameter: 'Clave del parámetro de análisis',
    symbology: 'Simbología del código de barras',
    valueTemplate: 'Plantilla de valor',
    gs1Segments: 'Segmentos GS1',
    gs1Hint: 'Formato: AI:origen:longitud fija, p. ej. 01:product.number:14, 10:batch.number',
    xMm: 'X (mm)',
    yMm: 'Y (mm)',
    widthMm: 'Ancho (mm)',
    heightMm: 'Alto (mm)',
    rotation: 'Rotación',
    fontSize: 'Tamaño de fuente (pt)',
    bold: 'Negrita',
    product: 'Artículo',
    batch: 'Lote',
    productionOrder: 'Orden de producción',
    declaration: 'Declaración',
    analysis: 'Análisis / nutrición',
    quantity: 'Cantidad',
    unit: 'Unidad',
    copies: 'Copias',
    reason: 'Motivo',
    note: 'Nota de revisión',
    languages: 'Idiomas',
  },
  columns: {
    ...labelsEn.columns,
    name: 'Nombre',
    version: 'Versión',
    format: 'Formato',
    status: 'Estado',
    updated: 'Actualizado',
    page: 'Página',
    grid: 'Cuadrícula',
    number: 'N.º de impresión',
    product: 'Artículo / lote',
    template: 'Plantilla',
    kind: 'Tipo',
    created: 'Creado',
    actions: 'Acciones',
  },
  media: { SHEET: 'Hoja', ROLL: 'Rollo' },
  versionStatuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    APPROVED: 'Aprobado',
    ARCHIVED: 'Archivado',
  },
  printKinds: {
    TEST: 'Impresión de prueba',
    PRODUCTION: 'Impresión de producción',
    REPRINT: 'Reimpresión',
  },
  printStatuses: { PENDING: 'Procesando', READY: 'Listo', FAILED: 'Fallido' },
  elementTypes: {
    TEXT: 'Texto',
    DYNAMIC_TEXT: 'Texto dinámico',
    BARCODE: 'Código de barras',
    QR_CODE: 'Código QR',
    LINE: 'Línea',
    BOX: 'Marco',
  },
  dynamicFields: {
    product: {
      number: 'Número de artículo',
      ean: 'EAN / GTIN',
      name: 'Nombre del artículo',
      externalName: 'Nombre externo',
      declarationName: 'Nombre de declaración',
    },
    declaration: {
      productName: 'Denominación legal',
      ingredients: 'Lista de ingredientes',
      allergens: 'Alérgenos',
      additives: 'Aditivos',
      warnings: 'Advertencias',
    },
    nutrition: { summary: 'Resumen nutricional' },
    analysis: { value: 'Valor de análisis' },
    batch: {
      number: 'Número de lote',
      bestBeforeDate: 'Fecha de consumo preferente',
      expiryDate: 'Fecha de caducidad',
      productionDate: 'Fecha de producción',
    },
    productionOrder: { number: 'Número de orden de producción' },
    quantity: { value: 'Cantidad', unit: 'Unidad' },
    storage: { instructions: 'Instrucciones de almacenamiento' },
  },
  actions: {
    ...labelsEn.actions,
    addElement: 'Añadir elemento',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    newVersion: 'Nueva versión',
    submit: 'Enviar',
    approve: 'Aprobar',
    archive: 'Archivar',
    preview: 'Vista previa',
    testPrint: 'Prueba',
    productionPrint: 'Impresión de producción',
    download: 'Abrir PDF',
    reprint: 'Reimprimir',
  },
  transition: {
    submit: {
      title: 'Enviar a revisión',
      description: 'El diseño queda bloqueado durante la revisión.',
    },
    approve: {
      title: 'Aprobar etiqueta',
      description:
        'La aprobación por cuatro ojos congela la versión para impresiones de producción.',
    },
    archive: {
      title: 'Archivar versión',
      description: 'Las versiones archivadas y sus evidencias de impresión permanecen inmutables.',
    },
  },
  copy: {
    title: 'Crear una nueva versión',
    description: 'La versión seleccionada se copia en un nuevo borrador editable.',
  },
  reprint: {
    title: 'Reimpresión justificada',
    description:
      'La versión histórica y la instantánea de datos se reutilizan exactamente. Indique el motivo de la nueva impresión.',
  },
  messages: {
    ...labelsEn.messages,
    invalid: 'Revise los datos introducidos.',
    formatSaved: 'El formato se guardó.',
    templateCreated: 'La plantilla se creó.',
    saved: 'El borrador se guardó.',
    submit: 'La versión se envió.',
    approve: 'La versión se aprobó.',
    archive: 'La versión se archivó.',
    versionCreated: 'Se creó una nueva versión de borrador.',
    printCreated: 'Se generó la impresión {{number}}.',
    reprintCreated: 'La reimpresión quedó registrada.',
    productRequired: 'Seleccione primero un artículo.',
    loadFailed: 'No se pudo cargar la plantilla de etiqueta.',
  },
} as const;
